import { defineStore } from 'pinia';
import { fetchWrapper } from '@/helpers';
import { useAlertStore } from '.';
// import { updateLicenses } from './account.store';
// import router from '@/router';

const baseUrl = `${process.env.VUE_APP_VUE_API_URL}`;

export const usePackageStore = defineStore('package', {
    state: () => ({
        countryList: [],
        packageList: [],
        plans: {
            monthly: null,
            weekly: null,
            daily: null
        }
    }),
    actions: {
        async getPackageList(searchQuery) {
            const alertStore = useAlertStore();
            try {
                const res = await fetchWrapper.post(`${baseUrl}/package/list`, { searchQuery });
                this.packageList = res.packageList;
                // await router.push(this.returnUrl || '/dashboard');
            } catch (error) {
                alertStore.error(error);
            }
        },

        async getItemList(fieldname, searchQuery) {
            const alertStore = useAlertStore();
            try {
                const res = await fetchWrapper.post(`${baseUrl}/package/get-item-list`, { fieldname, searchQuery });
                return { [fieldname]: res.fieldList }
                // this.fieldList = {...this.fieldList, [fieldname]:res.fieldList};
                // await router.push(this.returnUrl || '/dashboard');

            } catch (error) {
                alertStore.error(error);
            }
        },
        // Supports:
        // - getCountryList(serverType: string)
        // - getCountryList(needFingerPrint: boolean, needSocksUdp: boolean)
        async getCountryList(serverTypeOrNeedFingerPrint, needSocksUdp, ipVersion = 'ipv4') {
            const alertStore = useAlertStore();
            try {
                const payload = (typeof serverTypeOrNeedFingerPrint === 'string')
                    ? { serverType: serverTypeOrNeedFingerPrint, ip_version: ipVersion }
                    : {
                        serverType: 'XProxy',
                        ip_version: ipVersion,
                        // Only filter when YES is selected. If NO, omit so it shows all.
                        ...(serverTypeOrNeedFingerPrint === true ? { need_finger_print: true } : {}),
                        ...(needSocksUdp === true ? { need_socks_udp: true } : {}),
                    };
                const res = await fetchWrapper.post(`${baseUrl}/package/get-country-list`, payload);
                this.countryList = res.result
                // this.fieldList = {...this.fieldList, [fieldname]:res.fieldList};
                // await router.push(this.returnUrl || '/dashboard');

            } catch (error) {
                alertStore.error(error);
            }
        },
        // getCityList(countryName, isp, serverType, needFingerPrint?, needSocksUdp?)
        async getCityList(countryName, isp, serverType, needFingerPrint, needSocksUdp, ipVersion = 'ipv4') {
            const alertStore = useAlertStore();
            try {
                const payload = {
                    countryName,
                    isp,
                    serverType,
                    ip_version: ipVersion,
                    ...(needFingerPrint === true ? { need_finger_print: true } : {}),
                    ...(needSocksUdp === true ? { need_socks_udp: true } : {}),
                };
                const res = await fetchWrapper.post(`${baseUrl}/package/get-city-list`, payload);
                return res.result
                // this.fieldList = {...this.fieldList, [fieldname]:res.fieldList};
                // await router.push(this.returnUrl || '/dashboard');
            } catch (error) {
                alertStore.error(error);
            }
        },
        // getISPList(countryName, serverType, needFingerPrint?, needSocksUdp?)
        async getISPList(countryName,serverType, needFingerPrint, needSocksUdp, ipVersion = 'ipv4') {
            const alertStore = useAlertStore();
            try {
                const payload = {
                    countryName,
                    serverType,
                    ip_version: ipVersion,
                    ...(needFingerPrint === true ? { need_finger_print: true } : {}),
                    ...(needSocksUdp === true ? { need_socks_udp: true } : {}),
                };
                const res = await fetchWrapper.post(`${baseUrl}/package/get-isp-list`, payload);
                return res.result
                // this.fieldList = {...this.fieldList, [fieldname]:res.fieldList};
                // await router.push(this.returnUrl || '/dashboard');
            } catch (error) {   
                alertStore.error(error);
            }
        },
        async getPlans(countryName, isp, cityName, modems_id, ipVersion = 'ipv4') {
            const alertStore = useAlertStore();
            try {
                const res = await fetchWrapper.post(`${baseUrl}/package/get-plans`, { countryName, isp, cityName, modems_id, ip_version: ipVersion });
                this.plans.hourly = res.hour
                this.plans.daily = res.day
                this.plans.weekly = res.week
                this.plans.monthly = res.month
                return {
                    hourly: res.hour,
                    daily: res.day,
                    weekly: res.week,
                    monthly: res.month,
                }
            } catch (error) {
                alertStore.error(error);
            }
        },
        // Other actions...
    },
});
